/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class DataColumnDialog extends Common.GridEditorDialog<DataColumn> {
        protected getFormKey() { return DataColumnForm.formKey; }
        protected getNameProperty() { return "Name" }
        protected getEntitySingular() { return "Column"; }

        protected form = new DataColumnForm(this.idPrefix);

        private formatterOptions: Serenity.PropertyGrid;
        private editorOptions: Serenity.PropertyGrid;

        constructor() {
            super();

            this.createFormatterOptionsGrid();

            this.form.FormatterType.changeSelect2(e => this.createFormatterOptionsGrid())
            this.form.EditorType.changeSelect2(e => this.createEditorOptionsGrid());
        }

        public loadEntity(entity: DataColumn) {
            super.loadEntity(entity);

            this.createFormatterOptionsGrid();
            this.createEditorOptionsGrid();
            this.formatterOptions.load(entity.FormatterParams || {});
            this.editorOptions.load(entity.EditorParams || {});
        }

        protected getSaveEntity(): DataReportColumn {
            var e = super.getSaveEntity();
            e.FormatterParams = {};
            e.EditorParams = {};
            this.formatterOptions.save(e.FormatterParams);
            this.editorOptions.save(e.EditorParams);
            return e;
        }

        private createFormatterOptionsGrid() {
            var el: JQuery;
            if (this.formatterOptions) {
                el = this.formatterOptions.element;
                this.formatterOptions.destroy();
                this.formatterOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.propertyGrid.element);

            var items: Serenity.PropertyItem[];
            var formatterType = this.form.FormatterType.value;
            if (formatterType) {
                var ft = Q.getLookup<DataReportEditorTypeItem>("Data.DataReportFormatterType")
                    .itemById[formatterType];
                if (ft)
                    items = ft.Options;
            }

            items = Q.deepClone(items || []);
            for (var k of items)
                k.category = "Formatter Options";

            this.formatterOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "FmtOpt_",
                useCategories: true
            });

            this.formatterOptions.load({});
        }

        private createEditorOptionsGrid() {
            var el: JQuery;
            if (this.editorOptions) {
                el = this.editorOptions.element;
                this.editorOptions.destroy();
                this.editorOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.formatterOptions.element);

            var items: Serenity.PropertyItem[];
            var editorType = this.form.EditorType.value;
            if (editorType) {
                var ft = Q.getLookup<DataReportEditorTypeItem>("Data.DataReportEditorType")
                    .itemById[editorType];
                if (ft)
                    items = ft.Options;
            }

            items = Q.deepClone(items || []);
            for (var k of items)
                k.category = "Quick Filter Options";

            this.editorOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "FmtOpt_",
                useCategories: true
            });

            this.editorOptions.load({});
        }
    }
}